// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/view_compositor.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'view_compositorPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D viewTexture;
uniform vec2 viewPosition, viewSize;
void main() {
vec2 viewUv = (vUV - viewPosition) / viewSize;
if (viewUv.x < 0.0 || viewUv.y < 0.0 || viewUv.x >= 1.0|| viewUv.y >= 1.0) {
discard;
}
gl_FragColor = texture2D(viewTexture, viewUv);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const view_compositorPixelShader = { name, shader };
//# sourceMappingURL=view_compositor.fragment.js.map